import { createContext } from "react";

export const CompanyContext = createContext()